//@author devin
import { MasterDefinition } from "../master.definition";
import { EventNodeType } from "../../event.service";
import { Proto } from "../../../pojo/Proto";
import NumericalBoolean = Proto.NumericalBoolean;
import CharBoolean = Proto.CharBoolean;

export type EventType = {
    type_name: string;
    node_type: EventNodeType;
    type_id: number;
    parent_id: number;
    defn_state: NumericalBoolean;
    favorite: CharBoolean;
    node_type_name: string;
};

export class EventTypeService extends MasterDefinition<EventType> {
    private static singleton: MasterDefinition<EventType>;

    private static serviceUrl = "/evtype.json?node_type=E";
    private static rootNodeName = "event_types";
    private static itemNodeName = "event_type";
    private static idNodeName = "type_id";
    private static nameNodeName = "type_name";

    public constructor() {
        super(
            EventTypeService.serviceUrl,
            EventTypeService.rootNodeName,
            EventTypeService.itemNodeName,
            EventTypeService.idNodeName,
            EventTypeService.nameNodeName,
        );
    }

    public static getSingleton() {
        if (!EventTypeService.singleton) {
            EventTypeService.singleton = new EventTypeService();
        }
        return EventTypeService.singleton;
    }
}
